import * as XLSX from 'xlsx';

export const exportTestCasesToXLSX = (testCases, endpoint) => {

  const excelData = testCases.map(testCase => {

    const safeJsonParse = (jsonString, fallback = {}) => {
      if (!jsonString || jsonString.trim() === "") return fallback;
      try {
        if (typeof jsonString === "object") return JSON.stringify(jsonString, null, 2);
        return JSON.stringify(JSON.parse(jsonString), null, 2);
      } catch (error) {
        return jsonString || '';
      }
    };

    return {
      'Test Case Name': testCase.testCase || '',
      'HTTP Method': testCase.httpMethod || '',
      'Test Type': testCase.testType || '',
      'Expected Status Code': testCase.expectedStatusCode || '',
      'Endpoint Path': endpoint?.path || '',
      'Headers': safeJsonParse(testCase.headers),
      'Query Parameters': safeJsonParse(testCase.queryParams),
      'Body': safeJsonParse(testCase.body),
      'Body Type': testCase.bodyType || '',
      'Body Sub Type': testCase.bodySubType || '',
      'Created At': testCase.createdAt || '',
      'Updated At': testCase.updatedAt || '',
    };
  });


  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(excelData, {
    header: Object.keys(excelData[0] || {}),
  });

 
  const maxWidths = {};
  excelData.forEach(row => {
    Object.keys(row).forEach(key => {
      const value = String(row[key] || '');
      maxWidths[key] = Math.max(
        maxWidths[key] || 0,
        key.length,
        value.split('\n')[0].length
      );
    });
  });

  worksheet['!cols'] = Object.keys(maxWidths).map(key => ({
    wch: Math.min(maxWidths[key], 100) 
  }));


  XLSX.utils.book_append_sheet(workbook, worksheet, 'Test Cases');


  const fileName = `test_cases_${endpoint?.path?.replace(/[^a-zA-Z0-9]/g, '_') || 'all'}_${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};
